/**
 * Keep the native mini-cart in sync when shoppers add from Rebuy widgets.
 * - 301657: cart-drawer recommendations
 * - 301664: product-page frequently bought together
 * Smart Cart is not used.
 *
 * Also forces a full-width 2-column product grid in the cart drawer.
 * Rebuy's default large/medium/small-columns-* classes (e.g. columns-5 =
 * 20% each) leave two skinny cards on the left — we rewrite those classes
 * and apply important inline widths after every render.
 *
 * Cart recommendations are seeded from cart product IDs
 * (data-rebuy-shopify-product-ids) and re-mounted when the cart changes,
 * matching search/PDP behavior so recs are not a static default list.
 */
(function () {
  var CART_WIDGET_ID = '301657';
  var PDP_WIDGET_ID = '301664';
  var WIDGET_ID = CART_WIDGET_ID;
  var STYLE_ID = 'rebuy-cart-drawer-full-width-overrides';
  var lastCartSeed = null;
  var cartSyncTimer = null;
  var cartSyncInFlight = false;
  var cartSyncQueuedForce = null;

  function widgetId(widget) {
    return widget && widget.id != null ? String(widget.id) : '';
  }

  function isCartDrawerWidget(widget) {
    return widgetId(widget) === CART_WIDGET_ID;
  }

  function isThemeRebuyWidget(widget) {
    var id = widgetId(widget);
    return id === CART_WIDGET_ID || id === PDP_WIDGET_ID;
  }

  function refreshNativeCart() {
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { scrollToTop: false, skipLoadingStart: true }
      })
    );
  }

  function getCartMount() {
    var miniCart = document.getElementById('mini-cart');
    if (!miniCart) return null;
    return miniCart.querySelector(
      '[data-rebuy-id="' + WIDGET_ID + '"], #rebuy-widget-' + WIDGET_ID
    );
  }

  function getCartRebuyWrap() {
    var miniCart = document.getElementById('mini-cart');
    if (!miniCart) return null;
    return miniCart.querySelector('.mini-cart__rebuy');
  }

  function fetchCartProductIdsCsv() {
    return fetch(window.theme && window.theme.routes && window.theme.routes.cartUrl
      ? (window.theme.routes.cartUrl.replace(/\/$/, '') + '.js')
      : '/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart fetch failed');
        return response.json();
      })
      .then(function (cart) {
        var ids = [];
        var seen = {};
        (cart.items || []).forEach(function (item) {
          var id = item && item.product_id != null ? String(item.product_id) : '';
          if (!id || seen[id]) return;
          seen[id] = true;
          ids.push(id);
        });
        return ids.slice(0, 5).join(',');
      });
  }

  function buildCartMount(idsCsv) {
    var mount = document.createElement('div');
    mount.setAttribute('data-rebuy-id', WIDGET_ID);
    if (idsCsv) {
      mount.setAttribute('data-rebuy-shopify-product-ids', idsCsv);
    }
    return mount;
  }

  function ensureRebuyMount(idsCsv) {
    var miniCart = document.getElementById('mini-cart');
    if (!miniCart) return null;

    var existing = getCartMount();
    if (existing) {
      if (idsCsv != null) {
        if (idsCsv) {
          existing.setAttribute('data-rebuy-shopify-product-ids', idsCsv);
        } else {
          existing.removeAttribute('data-rebuy-shopify-product-ids');
        }
      }
      return existing;
    }

    // Prefer the active content area (empty or filled) so recommendations
    // stay visible even when the cart has no line items yet.
    var content =
      miniCart.querySelector('.mini-cart__content') ||
      miniCart.querySelector('.mini-cart__inner') ||
      miniCart;

    var wrap = document.createElement('div');
    wrap.className = content.classList.contains('mini-cart__content--empty')
      ? 'mini-cart__rebuy mini-cart__rebuy--empty'
      : 'mini-cart__rebuy';

    var title = document.createElement('p');
    title.className = 'mini-cart__rebuy-title';
    title.textContent = 'You may also like';
    wrap.appendChild(title);
    wrap.appendChild(buildCartMount(idsCsv || ''));
    content.appendChild(wrap);
    return getCartMount();
  }

  function remountCartRebuy(idsCsv) {
    var wrap = getCartRebuyWrap();
    if (!wrap) {
      ensureRebuyMount(idsCsv);
      return;
    }

    var title = wrap.querySelector('.mini-cart__rebuy-title');
    wrap.innerHTML = '';
    if (title) {
      wrap.appendChild(title);
    } else {
      var p = document.createElement('p');
      p.className = 'mini-cart__rebuy-title';
      p.textContent = 'You may also like';
      wrap.appendChild(p);
    }
    wrap.appendChild(buildCartMount(idsCsv || ''));
  }

  function initCartRebuyWidget() {
    // Single init path — do not also call widget.call() after Rebuy.init().
    try {
      if (window.Rebuy && typeof window.Rebuy.init === 'function') {
        window.Rebuy.init();
        return;
      }
    } catch (e) {}

    try {
      if (window.rebuy && typeof window.rebuy.init === 'function') {
        window.rebuy.init();
        return;
      }
    } catch (e) {}

    try {
      if (window.Rebuy && window.Rebuy.widgets && typeof window.Rebuy.widgets === 'object') {
        var widgets = window.Rebuy.widgets;
        var list = Array.isArray(widgets) ? widgets : Object.keys(widgets).map(function (key) {
          return widgets[key];
        });

        list.forEach(function (widget) {
          if (!isCartDrawerWidget(widget)) return;
          if (typeof widget.call === 'function') {
            widget.call();
          } else if (typeof widget.init === 'function') {
            widget.init();
          } else if (typeof widget.render === 'function') {
            widget.render();
          }
        });
      }
    } catch (e) {}
  }

  function cartWidgetHasProducts() {
    var root = document.getElementById('rebuy-widget-' + CART_WIDGET_ID);
    return !!(root && root.querySelector('.rebuy-product-block'));
  }

  function syncCartRebuyRecommendations(force) {
    if (cartSyncInFlight) {
      cartSyncQueuedForce = !!(cartSyncQueuedForce || force);
      return;
    }
    cartSyncInFlight = true;

    fetchCartProductIdsCsv()
      .then(function (idsCsv) {
        cartSyncInFlight = false;

        var mount = getCartMount();
        var current = mount
          ? mount.getAttribute('data-rebuy-shopify-product-ids') || ''
          : '';

        // Skip remount when seed is unchanged and products are already showing.
        if (
          !force &&
          idsCsv === lastCartSeed &&
          idsCsv === current &&
          cartWidgetHasProducts()
        ) {
          forceFullWidthTwoUp();
        } else {
          lastCartSeed = idsCsv;
          remountCartRebuy(idsCsv);
          initCartRebuyWidget();
          setTimeout(forceFullWidthTwoUp, 50);
          setTimeout(forceFullWidthTwoUp, 250);
        }

        if (cartSyncQueuedForce !== null) {
          var queuedForce = cartSyncQueuedForce;
          cartSyncQueuedForce = null;
          scheduleCartRebuySync(queuedForce, 50);
        }
      })
      .catch(function () {
        cartSyncInFlight = false;
        ensureRebuyMount();
        initCartRebuyWidget();
        forceFullWidthTwoUp();
        if (cartSyncQueuedForce !== null) {
          var queuedForce = cartSyncQueuedForce;
          cartSyncQueuedForce = null;
          scheduleCartRebuySync(queuedForce, 50);
        }
      });
  }

  function scheduleCartRebuySync(force, delay) {
    if (cartSyncTimer) clearTimeout(cartSyncTimer);
    cartSyncTimer = setTimeout(function () {
      cartSyncTimer = null;
      syncCartRebuyRecommendations(!!force);
    }, typeof delay === 'number' ? delay : 250);
  }

  function ensureOverrideStylesheet() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '.mini-cart__rebuy #rebuy-widget-' + WIDGET_ID + ',',
      '.mini-cart__rebuy #rebuy-widget-' + WIDGET_ID + ' .rebuy-widget-content,',
      '.mini-cart__rebuy #rebuy-widget-' + WIDGET_ID + ' .rebuy-widget-container,',
      '.mini-cart__rebuy #rebuy-widget-' + WIDGET_ID + ' .rebuy-product-grid {',
      '  width: 100% !important;',
      '  max-width: 100% !important;',
      '  box-sizing: border-box !important;',
      '}',
      '.mini-cart__rebuy #rebuy-widget-' + WIDGET_ID + ' .rebuy-product-grid {',
      '  display: flex !important;',
      '  flex-flow: row wrap !important;',
      '  justify-content: flex-start !important;',
      '  align-items: flex-start !important;',
      '  gap: 0 !important;',
      '}',
      '.mini-cart__rebuy #rebuy-widget-' + WIDGET_ID + ' .rebuy-product-grid .rebuy-product-block,',
      '.mini-cart__rebuy #rebuy-widget-' + WIDGET_ID + ' .rebuy-product-grid.large-columns-1 .rebuy-product-block,',
      '.mini-cart__rebuy #rebuy-widget-' + WIDGET_ID + ' .rebuy-product-grid.large-columns-2 .rebuy-product-block,',
      '.mini-cart__rebuy #rebuy-widget-' + WIDGET_ID + ' .rebuy-product-grid.large-columns-3 .rebuy-product-block,',
      '.mini-cart__rebuy #rebuy-widget-' + WIDGET_ID + ' .rebuy-product-grid.large-columns-4 .rebuy-product-block,',
      '.mini-cart__rebuy #rebuy-widget-' + WIDGET_ID + ' .rebuy-product-grid.large-columns-5 .rebuy-product-block,',
      '.mini-cart__rebuy #rebuy-widget-' + WIDGET_ID + ' .rebuy-product-grid.large-columns-6 .rebuy-product-block,',
      '.mini-cart__rebuy #rebuy-widget-' + WIDGET_ID + ' .rebuy-product-grid.medium-columns-1 .rebuy-product-block,',
      '.mini-cart__rebuy #rebuy-widget-' + WIDGET_ID + ' .rebuy-product-grid.medium-columns-2 .rebuy-product-block,',
      '.mini-cart__rebuy #rebuy-widget-' + WIDGET_ID + ' .rebuy-product-grid.medium-columns-3 .rebuy-product-block,',
      '.mini-cart__rebuy #rebuy-widget-' + WIDGET_ID + ' .rebuy-product-grid.medium-columns-4 .rebuy-product-block,',
      '.mini-cart__rebuy #rebuy-widget-' + WIDGET_ID + ' .rebuy-product-grid.medium-columns-5 .rebuy-product-block,',
      '.mini-cart__rebuy #rebuy-widget-' + WIDGET_ID + ' .rebuy-product-grid.medium-columns-6 .rebuy-product-block,',
      '.mini-cart__rebuy #rebuy-widget-' + WIDGET_ID + ' .rebuy-product-grid.small-columns-1 .rebuy-product-block,',
      '.mini-cart__rebuy #rebuy-widget-' + WIDGET_ID + ' .rebuy-product-grid.small-columns-2 .rebuy-product-block,',
      '.mini-cart__rebuy #rebuy-widget-' + WIDGET_ID + ' .rebuy-product-grid.small-columns-3 .rebuy-product-block,',
      '.mini-cart__rebuy #rebuy-widget-' + WIDGET_ID + ' .rebuy-product-grid.small-columns-4 .rebuy-product-block,',
      '.mini-cart__rebuy #rebuy-widget-' + WIDGET_ID + ' .rebuy-product-grid.small-columns-5 .rebuy-product-block,',
      '.mini-cart__rebuy #rebuy-widget-' + WIDGET_ID + ' .rebuy-product-grid.small-columns-6 .rebuy-product-block {',
      '  width: calc(50% - 6px) !important;',
      '  max-width: calc(50% - 6px) !important;',
      '  min-width: calc(50% - 6px) !important;',
      '  height: auto !important;',
      '  min-height: 0 !important;',
      '  flex: 0 0 calc(50% - 6px) !important;',
      '  align-self: flex-start !important;',
      '  justify-content: flex-start !important;',
      '  margin: 0 3px 12px !important;',
      '  box-sizing: border-box !important;',
      '}',
      '.mini-cart__rebuy #rebuy-widget-' + WIDGET_ID + ' .rebuy-product-info,',
      '.mini-cart__rebuy #rebuy-widget-' + WIDGET_ID + ' .rebuy-product-actions,',
      '.mini-cart__rebuy #rebuy-widget-' + WIDGET_ID + ' .rebuy-product-options,',
      '.mini-cart__rebuy #rebuy-widget-' + WIDGET_ID + ' .rebuy-product-controls {',
      '  flex: 0 0 auto !important;',
      '  min-height: 0 !important;',
      '  margin-top: 6px !important;',
      '}',
      '.mini-cart__rebuy #rebuy-widget-' + WIDGET_ID + ' .rebuy-product-info {',
      '  margin-top: 0 !important;',
      '}',
      '.mini-cart__rebuy #rebuy-widget-' + WIDGET_ID + ' .rebuy-button {',
      '  margin: 0 !important;',
      '}',
      '.mini-cart__rebuy #rebuy-widget-' + WIDGET_ID + ' .rebuy-product-media,',
      '.mini-cart__rebuy #rebuy-widget-' + WIDGET_ID + ' .rebuy-product-image {',
      '  max-height: 120px !important;',
      '  height: auto !important;',
      '  flex: 0 0 auto !important;',
      '}'
    ].join('\n');

    document.head.appendChild(style);
  }

  function forceTwoColumnGrid(widget) {
    if (!isCartDrawerWidget(widget) || !widget.data || !widget.data.settings) return;

    var settings = widget.data.settings;
    settings.display_type = 'grid';

    if (!settings.layout || typeof settings.layout !== 'object') {
      settings.layout = {};
    }

    settings.layout.large = 'grid';
    settings.layout.medium = 'grid';
    settings.layout.small = 'grid';

    settings.products_per_row = 2;
    settings.productsPerRow = 2;
    settings.columns_per_row = 2;

    if (!settings.layout.columns || typeof settings.layout.columns !== 'object') {
      settings.layout.columns = {};
    }
    settings.layout.columns.large = 2;
    settings.layout.columns.medium = 2;
    settings.layout.columns.small = 2;

    if (!settings.columns || typeof settings.columns !== 'object') {
      settings.columns = {};
    }
    settings.columns.large = 2;
    settings.columns.medium = 2;
    settings.columns.small = 2;

    if (settings.images && typeof settings.images === 'object') {
      settings.images.width = '';
      settings.images.height = '';
      settings.images.size = '400x400';
    }
  }

  function forceFullWidthTwoUp() {
    ensureOverrideStylesheet();

    var root = document.getElementById('rebuy-widget-' + WIDGET_ID);
    if (!root) return;

    root.style.setProperty('width', '100%', 'important');
    root.style.setProperty('max-width', '100%', 'important');

    root.querySelectorAll('.rebuy-widget-content, .rebuy-widget-container').forEach(function (el) {
      el.style.setProperty('width', '100%', 'important');
      el.style.setProperty('max-width', '100%', 'important');
    });

    root.querySelectorAll('.rebuy-product-grid').forEach(function (grid) {
      // Rewrite Rebuy column classes (columns-5 => 20% each) to columns-2.
      grid.className = grid.className
        .replace(/\b(large|medium|small)-columns-\d+\b/g, '')
        .replace(/\b(large|medium|small)-style-(line|list)\b/g, '')
        .replace(/\s+/g, ' ')
        .trim();

      grid.classList.add('large-columns-2', 'medium-columns-2', 'small-columns-2');

      grid.style.setProperty('display', 'flex', 'important');
      grid.style.setProperty('flex-flow', 'row wrap', 'important');
      grid.style.setProperty('justify-content', 'flex-start', 'important');
      grid.style.setProperty('align-items', 'flex-start', 'important');
      grid.style.setProperty('width', '100%', 'important');
      grid.style.setProperty('max-width', '100%', 'important');
      grid.style.setProperty('transform', 'none', 'important');
      grid.style.setProperty('left', 'auto', 'important');

      grid.querySelectorAll('.rebuy-product-block').forEach(function (el) {
        el.style.setProperty('width', 'calc(50% - 6px)', 'important');
        el.style.setProperty('max-width', 'calc(50% - 6px)', 'important');
        el.style.setProperty('min-width', 'calc(50% - 6px)', 'important');
        el.style.setProperty('height', 'auto', 'important');
        el.style.setProperty('min-height', '0', 'important');
        el.style.setProperty('flex', '0 0 calc(50% - 6px)', 'important');
        el.style.setProperty('align-self', 'flex-start', 'important');
        el.style.setProperty('justify-content', 'flex-start', 'important');
        el.style.setProperty('margin', '0 3px 12px', 'important');
        el.style.setProperty('left', 'auto', 'important');
        el.style.setProperty('position', 'relative', 'important');
        el.style.setProperty('box-sizing', 'border-box', 'important');
      });

      grid.querySelectorAll('.rebuy-product-image, .rebuy-product-media').forEach(function (el) {
        el.style.setProperty('width', '100%', 'important');
        el.style.setProperty('max-width', '100%', 'important');
        el.style.setProperty('height', 'auto', 'important');
        el.style.setProperty('max-height', '120px', 'important');
        el.style.setProperty('flex', '0 0 auto', 'important');
      });

      grid.querySelectorAll('.rebuy-product-info, .rebuy-product-actions, .rebuy-product-options, .rebuy-product-controls').forEach(function (el) {
        el.style.setProperty('flex', '0 0 auto', 'important');
        el.style.setProperty('min-height', '0', 'important');
        el.style.setProperty('height', 'auto', 'important');
      });

      grid.querySelectorAll('.rebuy-product-actions, .rebuy-product-options, .rebuy-product-controls').forEach(function (el) {
        el.style.setProperty('margin-top', '6px', 'important');
      });

      grid.querySelectorAll('.rebuy-button').forEach(function (el) {
        el.style.setProperty('margin', '0', 'important');
      });
    });
  }

  function forcePdpTwoColumnGrid(widget) {
    if (widgetId(widget) !== PDP_WIDGET_ID || !widget.data || !widget.data.settings) return;

    var settings = widget.data.settings;
    settings.display_type = 'grid';

    if (!settings.layout || typeof settings.layout !== 'object') {
      settings.layout = {};
    }

    settings.layout.large = 'grid';
    settings.layout.medium = 'grid';
    settings.layout.small = 'grid';
    settings.products_per_row = 2;
    settings.productsPerRow = 2;
    settings.columns_per_row = 2;

    if (!settings.layout.columns || typeof settings.layout.columns !== 'object') {
      settings.layout.columns = {};
    }
    settings.layout.columns.large = 2;
    settings.layout.columns.medium = 2;
    settings.layout.columns.small = 2;

    if (!settings.columns || typeof settings.columns !== 'object') {
      settings.columns = {};
    }
    settings.columns.large = 2;
    settings.columns.medium = 2;
    settings.columns.small = 2;
  }

  function forcePdpTwoUp() {
    var root = document.getElementById('rebuy-widget-' + PDP_WIDGET_ID);
    if (!root) return;

    root.querySelectorAll('.rebuy-product-grid').forEach(function (grid) {
      grid.className = grid.className
        .replace(/\b(large|medium|small)-columns-\d+\b/g, '')
        .replace(/\b(large|medium|small)-style-(line|list)\b/g, '')
        .replace(/\b(large|medium|small)-carousel\b/g, '')
        .replace(/\s+/g, ' ')
        .trim();

      grid.classList.add('large-columns-2', 'medium-columns-2', 'small-columns-2');

      grid.style.setProperty('display', 'flex', 'important');
      grid.style.setProperty('flex-flow', 'row wrap', 'important');
      grid.style.setProperty('justify-content', 'flex-start', 'important');
      grid.style.setProperty('align-items', 'flex-start', 'important');
      grid.style.setProperty('width', '100%', 'important');
      grid.style.setProperty('transform', 'none', 'important');
      grid.style.setProperty('left', 'auto', 'important');

      grid.querySelectorAll('.rebuy-product-block').forEach(function (el) {
        el.style.setProperty('width', 'calc(50% - 6px)', 'important');
        el.style.setProperty('max-width', 'calc(50% - 6px)', 'important');
        el.style.setProperty('min-width', 'calc(50% - 6px)', 'important');
        el.style.setProperty('flex', '0 0 calc(50% - 6px)', 'important');
        el.style.setProperty('margin', '0 3px 10px', 'important');
        el.style.setProperty('height', 'auto', 'important');
        el.style.setProperty('left', 'auto', 'important');
        el.style.setProperty('position', 'relative', 'important');
      });
    });
  }

  document.addEventListener('rebuy.beforeReady', function (event) {
    var widget = (event.detail || {}).widget;
    forceTwoColumnGrid(widget);
    forcePdpTwoColumnGrid(widget);
  });

  document.addEventListener('rebuy.ready', function (event) {
    var widget = (event.detail || {}).widget;
    forceTwoColumnGrid(widget);
    forcePdpTwoColumnGrid(widget);
    forceFullWidthTwoUp();
    forcePdpTwoUp();
  });

  document.addEventListener('rebuy.productsChange', function (event) {
    var widget = (event.detail || {}).widget;
    if (isCartDrawerWidget(widget)) {
      forceFullWidthTwoUp();
    }
    if (widgetId(widget) === PDP_WIDGET_ID) {
      forcePdpTwoUp();
    }
  });

  function openNativeCartDrawer() {
    if (typeof window.__warehouseOpenCartDrawer === 'function') {
      window.__warehouseOpenCartDrawer();
      return;
    }

    var miniCart = document.getElementById('mini-cart');
    if (miniCart && miniCart.getAttribute('aria-hidden') !== 'false') {
      var toggle = document.querySelector('[data-action="toggle-mini-cart"]');
      if (toggle) toggle.click();
    }
  }

  document.addEventListener('rebuy.add', function (event) {
    var detail = event.detail || {};
    if (!isThemeRebuyWidget(detail.widget)) return;
    refreshNativeCart();

    // PDP frequently-bought-together adds should open the drawer so the
    // shopper sees the item land in cart (same UX as normal ATC).
    if (widgetId(detail.widget) === PDP_WIDGET_ID) {
      openNativeCartDrawer();
    }

    // Cart changed via Rebuy ATC — refresh seeded recommendations shortly
    // after the native cart snapshot lands.
    scheduleCartRebuySync(true, 400);
  });

  document.documentElement.addEventListener('cart:refresh', function () {
    // In-place cart updates leave the Rebuy mount alone; re-seed after the
    // snapshot settles so recommendations track the new cart contents.
    scheduleCartRebuySync(false, 350);
  });

  document.documentElement.addEventListener('cart:rerendered', function () {
    scheduleCartRebuySync(true, 100);
  });

  document.addEventListener('DOMContentLoaded', function () {
    ensureOverrideStylesheet();
    forcePdpTwoUp();
    // Prefer Liquid-seeded IDs on first paint; still sync from /cart.js so
    // client-side cart mutations before first open stay correct.
    scheduleCartRebuySync(false, 0);
  });

  // Rebuy can re-apply column/carousel classes after ready; keep watching.
  // Also re-sync when the drawer opens so stale seeds catch up.
  if (typeof MutationObserver !== 'undefined') {
    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        if (document.getElementById('rebuy-widget-' + CART_WIDGET_ID)) {
          forceFullWidthTwoUp();
        }
        if (document.getElementById('rebuy-widget-' + PDP_WIDGET_ID)) {
          forcePdpTwoUp();
        }
      });
    });

    document.addEventListener('DOMContentLoaded', function () {
      var miniCart = document.getElementById('mini-cart');
      if (miniCart) {
        observer.observe(miniCart, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class', 'style']
        });

        var openObserver = new MutationObserver(function () {
          if (miniCart.getAttribute('aria-hidden') === 'false') {
            scheduleCartRebuySync(false, 50);
          }
        });
        openObserver.observe(miniCart, {
          attributes: true,
          attributeFilter: ['aria-hidden']
        });
      }

      var pdpMount = document.querySelector('.product-rebuy');
      if (pdpMount) {
        observer.observe(pdpMount, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class', 'style']
        });
      }
    });
  }
})();
